import { useMatchRoute } from "@tanstack/react-router";

import type { FileRoutesByTo } from "@/routeTree.gen";

export enum AppLayout {
  Default = "default",
  Aside = "aside",
  Navless = "navless",
  Headerless = "headerless",
  Promo = "promo",
}

const asideLayoutRoutes: (keyof FileRoutesByTo)[] = [
  "/login",
  "/login-sso",
  "/logout",
  "/register",
  "/account/verify/complete-invite",
  "/account/verify/complete-signup",
  "/account/password/request",
  "/account/password/reset",
  "/account/password/set",
  "/account/verify/$type/$token",
];

const navlessLayoutRoutes: (keyof FileRoutesByTo)[] = [
  "/account/profile",
  "/welcome",
  "/end-of-trial",
  "/terms-trial",
  "/privacy",
];

const headerlessLayoutRoutes: (keyof FileRoutesByTo)[] = ["/customer-portal", "/customer-portal/$public_portal_token"];

const promoLayoutRoutes: (keyof FileRoutesByTo)[] = ["/free-trial"];

export function useAppLayout() {
  const matchRoute = useMatchRoute();

  let appLayout: AppLayout | null = null;

  if (asideLayoutRoutes.some((path) => matchRoute({ to: path }))) {
    appLayout = AppLayout.Aside;
  } else if (navlessLayoutRoutes.some((path) => matchRoute({ to: path }))) {
    appLayout = AppLayout.Navless;
  } else if (headerlessLayoutRoutes.some((path) => matchRoute({ to: path }))) {
    appLayout = AppLayout.Headerless;
  } else if (promoLayoutRoutes.some((path) => matchRoute({ to: path }))) {
    appLayout = AppLayout.Promo;
  } else {
    appLayout = AppLayout.Default;
  }

  return { appLayout };
}
